/**
 * Where a category card's "See actions" goes: the Agent Actions page for that
 * category at that level (mailbox, Threads/Emails, tab). The page reads the
 * same parameters back, so the link is shareable.
 */
export const AGENT_ACTIONS_PATH = '/comms/actions'

export interface AgentActionsContext {
    /** null = every mailbox. */
    mailbox: string | null
    view: 'threads' | 'emails'
    /** all | waiting | archived | letter:<kind> */
    bucket: string
    /** Category (Emails) or outcome (Threads) key; null = everything at this level. */
    category: string | null
}

export const agentActionsHref = ({ mailbox, view, bucket, category }: AgentActionsContext): string => {
    const params = new URLSearchParams({ view, bucket })
    if (mailbox) params.set('mailbox', mailbox)
    if (category) params.set('category', category)
    return `${AGENT_ACTIONS_PATH}?${params.toString()}`
}

export const readAgentActionsContext = (search: string): AgentActionsContext => {
    const params = new URLSearchParams(search)
    const view = params.get('view') === 'emails' ? 'emails' : 'threads'
    return { mailbox: params.get('mailbox') || null, view, bucket: params.get('bucket') || 'all', category: params.get('category') || null }
}
